import React, { useRef, useState } from "react";
import { DirectUploadProvider } from "react-activestorage-provider";
import config from "../Config";

const DragAndDrop = ({ handleImage, product }) => {
  let uploadUrl = config.api.uploadUrl;
  const fileRef = useRef();
  const [image, setImage] = useState();

  const handleOnChangeOrDrop = (e, handleUpload) => {
    handleUpload(e.currentTarget.files);
    var reader = new FileReader();

    reader.onload = function (e) {
      setImage(reader.result);
    };
    reader.readAsDataURL(e.currentTarget.files[0]);
  };

  return (
    <DirectUploadProvider
      id="image"
      onSuccess={(r) => handleImage(r)}
      directUploadsPath={uploadUrl}
      render={({ handleUpload, uploads, ready }) => (
        <div>
          <div className="min-h-36 p-4 flex flex-col relative mt-6 justify-center border-dashed border-2 rounded-md">
            <input
              ref={fileRef}
              id="file"
              type="file"
              className="-ml-4 absolute opacity-0 h-full w-full cursor-pointer"
              disabled={!ready}
              onChange={(e) => handleOnChangeOrDrop(e, handleUpload)}
            />
            <label
              htmlFor="file"
              className="text-center"
              onDrop={(e) => handleOnChangeOrDrop(e, handleUpload)}
            >
              {product.image ? (
                <>
                  <img
                    src={image}
                    alt="product"
                    className="max-h-36 max-w-36 m-auto mb-4"
                  />
                  Click or drag and drop to replace photo
                </>
              ) : (
                "Click or drag and drop to add a photo"
              )}
            </label>
          </div>

          {uploads.forEach((upload) => {
            switch (upload.state) {
              case "waiting":
                return (
                  <p key={upload.id}>Waiting to upload {upload.file.name}</p>
                );
              case "uploading":
                return (
                  <p key={upload.id}>
                    Uploading {upload.file.name}: {upload.progress}%
                  </p>
                );
              case "error":
                return (
                  <p key={upload.id}>
                    Error uploading {upload.file.name}: {upload.error}
                  </p>
                );
              case "finished":
                return (
                  <p key={upload.id}>Finished uploading {upload.file.name}</p>
                );
              default:
            }
          })}
        </div>
      )}
    />
  );
};
export default DragAndDrop;
